/**
 * Presale OTP editor and sender share the approved, full-width layout.
 * Editing copy never restores the legacy card. OTP lifecycle is unchanged.
 */
import { PRESALE_CODE_LAYOUT, PRESALE_APPROVED_DEFAULTS } from './presale-email-layout.mjs';

export const PRESALE_EMAIL_LANGS = ['es', 'en', 'fr', 'it', 'pt', 'de'];
export const PRESALE_EMAIL_LANG_NAMES = { es: 'Español', en: 'English', fr: 'Français', it: 'Italiano', pt: 'Português', de: 'Deutsch' };
export const CODE_PLACEHOLDER = '{{code}}';
export const SAMPLE_CODE = '482913';
export const PRESALE_EMAIL_DEFAULTS = PRESALE_APPROVED_DEFAULTS;
export const PRESALE_EMAIL_FIELDS = [
    { key: 'subject', label: 'Asunto', max: 150, required: true },
    { key: 'preheader', label: 'Texto de vista previa (bandeja de entrada)', max: 200 },
    { key: 'title', label: 'Título', max: 120, required: true },
    { key: 'intro', label: 'Texto principal (antes del código)', max: 1000, multiline: true },
    { key: 'codeNote', label: 'Nota bajo el código', max: 1000, multiline: true },
    { key: 'outro', label: 'Texto final', max: 1000, multiline: true },
    { key: 'footer', label: 'Pie', max: 200, multiline: true }
];
export const isPresaleLang = lang => PRESALE_EMAIL_LANGS.includes(lang);

export function cleanPresaleEmailFields(input) {
    const src = input && typeof input === 'object' ? input : {};
    const fields = {};
    for (const f of PRESALE_EMAIL_FIELDS) {
        let value = typeof src[f.key] === 'string' ? src[f.key] : '';
        value = value.replace(/\r\n?/g, '\n');
        value = f.multiline ? value.replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim() : value.replace(/\s+/g, ' ').trim();
        if (value.length > f.max) return { ok: false, error: 'too_long', field: f.key, max: f.max };
        if (f.required && !value) return { ok: false, error: 'required', field: f.key };
        fields[f.key] = value;
    }
    return { ok: true, fields };
}
const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const lines = value => esc(value).replace(/\n/g, '<br>');

export function renderPresaleCodeEmail(fields, code = CODE_PLACEHOLDER, language = 'es') {
    const lang = isPresaleLang(language) ? language : 'en';
    const f = { ...PRESALE_EMAIL_DEFAULTS[lang], ...(fields || {}) };
    // Approved rows retain their original brand/help metadata. Expose both in
    // the existing editable footer without changing the stored database row.
    if (f.brand && f.help) f.footer = f.brand + '\n\n' + f.help;
    const footer = String(f.footer || '').split(/\n{2,}/).filter(Boolean)
        .map(p => '<p style="font-size:13px;line-height:1.65;margin:0 0 10px;color:#e2edf5">' + lines(p) + '</p>').join('');
    const values = { LANG: lang, SUBJECT: esc(f.subject), PREHEADER: esc(f.preheader),
        TITLE: esc(f.title), INTRO: lines(f.intro), CODE: code === CODE_PLACEHOLDER ? CODE_PLACEHOLDER : esc(code),
        CODENOTE: lines(f.codeNote), OUTRO: lines(f.outro), FOOTER: footer };
    const html = PRESALE_CODE_LAYOUT.replace(/@@(LANG|SUBJECT|PREHEADER|TITLE|INTRO|CODE|CODENOTE|OUTRO|FOOTER)@@/g, (_, key) => values[key]);
    const text = [f.title, f.intro, code, f.codeNote, f.outro, f.footer].map(s => String(s || '').trim()).filter(Boolean).join('\n\n');
    return { subject: f.subject, html, text };
}

export function rowToTemplate(row) {
    let fields = null;
    try { fields = JSON.parse(row.fields || 'null'); } catch {}
    if (fields?.brand && fields?.help) {
        fields.footer = fields.brand + '\n\n' + fields.help;
        delete fields.brand;
        delete fields.help;
    }
    return { lang: row.lang, fields, updatedAt: row.updated_at ? Number(row.updated_at) * 1000 : null, updatedBy: row.updated_by || null };
}
